import {
  colors,
  FormControl,
  FormHelperText,
  FormLabel,
  styled,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller } from "react-hook-form";

const CustomBorderDatePicker = styled(DatePicker)`
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #3a3a3a;
    }
  }
`;

const ReactiveDatePickerField = (props) => {
  const {
    hookFormControl,
    label,
    formLabel,
    varName,
    disabled = false,
    readOnly = false,
    errorMessage,
    minDate = null,
    maxDate = null,
    width = "100%",
    size = "small",
    variant = "outlined",
    required = false,
  } = props;

  return (
    <>
      <FormControl
        error={errorMessage !== null}
        variant={variant}
        size={size}
        sx={{ width }}
      >
        {formLabel && (
          <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">
            {formLabel}
          </FormLabel>
        )}
        {/* <InputLabel htmlFor={varName}>{label}</InputLabel> */}
        <Controller
          name={varName}
          control={hookFormControl}
          render={({ field }) => (
            <CustomBorderDatePicker
              variant={variant}
              disabled={disabled}
              readOnly={readOnly}
              format="dd/MM/yyyy"
              {...field}
              label={label}
              minDate={minDate}
              maxDate={maxDate}
              slotProps={{
                textField: {
                  size,
                  required: required,
                  inputProps: {
                    className: "font-['Poppins-Regular'] text-[15px]",
                  },
                  InputLabelProps: {
                    className: "font-['Poppins-Regular'] text-[15px]",
                  },
                },
              }}
            />
          )}
        />
        {errorMessage && (
          <FormHelperText
            className="ml-0 font-['Poppins-Regular']"
            id="component-error-text"
          >
            {errorMessage}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default ReactiveDatePickerField;
